var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.213,
    height: 14.798,
    viewBox: "0 0 17.213 14.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.557,13.579H16.668v1.71H.557ZM17.166,5.642a1.21,1.21,0,0,1-.119.955,1.292,1.292,0,0,1-.776.617L11.736,8.407,8.076,9.4,3.542,10.6l-1.353.4L1.552,9.839,0,7.174l1.233-.358L2.9,8.129,7.122,7.015,3.62.929,5.252.491,11.1,5.941l4.5-1.194a1.148,1.148,0,0,1,.975.119,1.288,1.288,0,0,1,.6.776Z",
    transform: "translate(-0.001 -0.491)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepart);
export default __webpack_public_path__ + "static/media/Depart.0f025efdaf5a016cf04766d3a39f5f6f.svg";
export { ForwardRef as ReactComponent };